// extracted by mini-css-extract-plugin
export default {"emote":"_2TE0l"};